import { DEFAULT_INBOX_WIDTH } from "../../constants/inbox/inbox";
import { DefaultPreferenceOptions } from "../../constants/userPreference";
import {
  CalendarViewType,
  DefaultDurationOption,
  StartOfWeekOption,
  TimeFormatOption,
} from "../../types/account/enum";
import { PreferencesType } from "../../types/account/type";
import { inboxActiveTab } from "../../types/inbox/enum";
import { DEFAULT_INBOX_ACCORDION, InboxAccordion } from "../../types/inbox/type";
import { loadFromLocalStorage } from "../../utils/localStorage/localStorage";
import { BlockVisibilityType } from "../../types/block/enum";

export const migrateOldPreferences = (): PreferencesType | null => {
  const mapDurationValue = (val: string | null): PreferencesType["defaultDuration"] => {
    switch (val) {
      case "15":
        return DefaultDurationOption.MIN15;
      case "30":
        return DefaultDurationOption.MIN30;
      case "60":
        return DefaultDurationOption.MIN60;
      default:
        return DefaultPreferenceOptions.defaultDuration;
    }
  };

  const mapStartOfWeek = (val: string | null): StartOfWeekOption => {
    switch (val) {
      case "Sunday":
        return StartOfWeekOption.SUNDAY;
      case "Monday":
        return StartOfWeekOption.MONDAY;
      default:
        return DefaultPreferenceOptions.startOfWeek;
    }
  };

  const parsePx = (val: string): number =>
    parseInt(val.replace("px", ""), 10) ?? DEFAULT_INBOX_WIDTH;

  const convertAccordion = (val: any): InboxAccordion => {
    const result: InboxAccordion = {
      [inboxActiveTab.INBOX]: { overdue: false, completed: false },
      [inboxActiveTab.TODAY]: { overdue: false, completed: false },
    };
    for (const tab in val) {
      if (tab in result) {
        result[tab as keyof InboxAccordion] = {
          overdue: Boolean(val[tab]?.overdue),
          completed: Boolean(val[tab]?.completed),
        };
      }
    }
    return result;
  };

  // 먼저 모든 값을 get
  const oldValues = {
    calendarViewType: loadFromLocalStorage<CalendarViewType>("calendarViewType"),
    defaultDuration: loadFromLocalStorage<string>("defaultDuration"),
    visibility: loadFromLocalStorage<BlockVisibilityType>("visibility"),
    startOfWeek: loadFromLocalStorage<string>("startOfWeek"),
    timeFormat: loadFromLocalStorage<TimeFormatOption>("timeFormat"),
    selectedSpaceIds: loadFromLocalStorage<number[]>("moba_selectedSpaceIdListState"),
    toggleVisibility: loadFromLocalStorage<string>("toggleVisibility"),
    savedWidth: loadFromLocalStorage<string>("savedWidth"),
  };

  // 가져온 값으로 마이그레이션 수행
  const calendarViewType = oldValues.calendarViewType ?? DefaultPreferenceOptions.calendarViewType;
  const defaultDuration = mapDurationValue(oldValues.defaultDuration);
  const defaultVisibility = oldValues.visibility ?? DefaultPreferenceOptions.defaultVisibility;
  const startOfWeek = mapStartOfWeek(oldValues.startOfWeek);
  const timeFormat = oldValues.timeFormat ?? DefaultPreferenceOptions.timeFormat;
  const selectedSpaceIds = oldValues.selectedSpaceIds ?? [];
  const inboxAccordion = convertAccordion(oldValues.toggleVisibility ?? DEFAULT_INBOX_ACCORDION);
  const savedInboxWidth = parsePx(oldValues.savedWidth ?? `${DEFAULT_INBOX_WIDTH}px`);

  const migratedPreference = {
    ...DefaultPreferenceOptions,
    calendarViewType,
    defaultDuration,
    defaultVisibility,
    startOfWeek,
    timeFormat,
    selectedSpaceIds,
    inboxAccordion,
    savedInboxWidth,
    spaceShow: DefaultPreferenceOptions.spaceShow,
    mobileView: DefaultPreferenceOptions.mobileView,
    inboxActiveTab: DefaultPreferenceOptions.inboxActiveTab,
  };

  // 모든 값을 수집한 후에 이전 값들 삭제
  Object.keys(oldValues).forEach((key) => {
    if (key === "moba_selectedSpaceIdListState") {
      localStorage.removeItem("moba_selectedSpaceIdListState");
    } else {
      localStorage.removeItem(key);
    }
  });

  return migratedPreference as PreferencesType;
};
